import react , {useEffect , useState} from "react";
import {
    useParams,
    Link
} from "react-router-dom";
import axios from "axios";

function UpdateComp(props){
    let id = props.iid;
    const [update,setupdate] = useState(false);
    const [object,setobject] = useState({});
    const [url,seturl] = useState("");
    const recieve= async (id)=>{
        const response = await fetch("https://lit-fjord-67974.herokuapp.com/friends/"+id);
        try {
            const recieved = await response.json();
            console.log(recieved)
            return recieved
        }catch(err){
            console.log(err)
        }
    }
    const updateee= async ()=>{
        const response = await fetch("https://lit-fjord-67974.herokuapp.com/update/"+id,{
            method:"PATCH",
            credentials:"include",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify(object)
        });
        try {
            const recieved = await response.json();
            return recieved
        }catch(err){
            console.log(err)
        }
    }
    function change(event){
        const {name, value}=event.target;
       setobject((prev)=>{
           return({
               ...prev,
               [name]:value
           })
       })
    }
     
    function submit(){
        // Axios.post("https://lit-fjord-67974.herokuapp.com/stats",formdata,config);
        // update({
        // Username:doc.Username,
        // Hash:doc.Password,
        // Gender:doc.Gender,
        // DateOfBirth:doc.DateOfBirth,
        // KnownAs:doc.KnownAs,
        // Introduction:doc.Introduction,
        // Interests:doc.Interests,
        // City:doc.City,
        // Country:doc.Country    
        // }).then((res)=>{
            
        // })
        updateee().then(()=>{
            setupdate(false)
            recieve(id).then((doc)=>{
                setobject(doc);
                seturl(`https://lit-fjord-67974.herokuapp.com/image/${doc.photos[0].url}`);
              });
        })
    
    }
 const uploadphoto = (event)=>{
    const config = {
        "Content-Type":"multipart/form-data"
    }
    const formdata = new FormData();
    console.log(event.target.files[0])
    formdata.append("photo",event.target.files[0])
    for (var pair of formdata.entries()) {
        console.log(pair[0]); 
    }
    axios.post("https://lit-fjord-67974.herokuapp.com/updatephoto/"+id,formdata,config).then(()=>{
        recieve(id).then((doc)=>{
            seturl(`https://lit-fjord-67974.herokuapp.com/image/${doc.photos[0].url}`);  
        })
    })
 }

    useEffect(()=>{
      recieve(id).then((doc)=>{
          setobject(doc);
          seturl(`https://lit-fjord-67974.herokuapp.com/image/${doc.photos[0].url}`);  
        });
      
    },[]);
    
        return (
            update==false?
            <div className = "profile">
                <div>
                <img className="profile-img" src={url}/> 
                <label for = "files" className="files" >Upload Photo</label>
                <input type ="file" onChange={uploadphoto} id="files" style={{visibility:"hidden"}}/>
                </div>
                
              <div className="profile-list-container">
                    <ul >
            
                    <li><strong>Username:</strong> {object.Username}</li>
                    <li><strong>Born:</strong>{object.DateOfBirth}</li>
                    <li><strong>Nickname:</strong>{object.KnownAs}</li>
                    <li><strong>Introducion:</strong></li>
                    <li>{object.Introduction}</li>
                    <li><strong>Interests:</strong></li>
                    <li>{object.Interests}</li>
                    <li><strong>City:</strong>{object.City}</li>
                    <li><strong>Country:</strong>{object.Country}</li>
                    <li><button type="button" onClick={()=>{
                        setupdate(true)
                    }} >Update</button></li>
                </ul>
                </div>
                </div>
                :
                <div className = "profile">
                <div className="img-holder">
                <img className="profile-img" src={url}/> 
                <label for = "files" className="files" >Upload Photo</label>
                <input type ="file" onChange={uploadphoto} id="files" style={{visibility:"hidden"}}/>
                </div>
                <div className="profile-list-container" >
                <input onChange={change} type="text" value={object.Username} name="Username" placeholder="Username"/>
                
                <br/>
               
                <select onChange={change} name="Gender" style={{marginBottom:"20px",width:"80%"}} value={object.Gender} placeholder="Gender">
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                </select>
                <br/>
                <input onChange={change} type="text" value={object.DateOfBirth} name="DateOfBirth" placeholder="Date Of Birth"/>
                <br/>
                <input onChange={change} type="text" value={object.KnownAs} name="KnownAs" placeholder="Known As" />
                <br/>
                <textarea onChange={change} rows={8} cols={44} style={{marginBottom:"20px"}} value={object.Introduction} name="Introduction" placeholder="Introduction" />
                <br/>
                <textarea onChange={change} rows={8} cols={44}  value={object.Interests} name="Interests" placeholder="Interests"></textarea>
                <br/>
                <input onChange={change} type="text" value={object.City} name="City" placeholder="City" />
                <br/>
                <input onChange={change} type="text" value={object.Country} name="Country" placeholder="Country" /> 
               
                <button type="submit"style={{marginRight:"10px"}} onClick={submit}>Submit</button><button type="button" onClick={()=>{
                        setupdate(false)
                    }} >Cancel</button>
                </div>
                </div>
        )
    
}
export default UpdateComp